export default {"src":"/_next/static/media/happy.1248e107.svg","height":582,"width":595,"blurWidth":0,"blurHeight":0};